import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import {
  getUserPreference,
  patchUserPreference,
  postUserPreference,
  postWhatsappVerification,
} from './api';
import { UserPreference } from './type';

type GetUserPreferenceArgs = Omit<
  UseQueryOptions<UserPreference>,
  'queryKey' | 'queryFn'
> & {
  profileId: string;
};
export const useGetUserPreference = ({
  profileId,
  ...args
}: GetUserPreferenceArgs) => {
  return useQuery({
    queryKey: ['user-preferences', profileId],
    queryFn: getUserPreference,
    ...args,
  });
};

export const usePostUserPreference = (
  args?: Omit<UseMutationOptions<unknown, Error, unknown>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: postUserPreference,
    ...args,
  });
};

export const useUpdateUserPreference = (
  args?: Omit<UseMutationOptions<unknown, Error, unknown>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: patchUserPreference,
    ...args,
  });
};

export const usePostWhatsappVerification = (
  args?: Omit<UseMutationOptions<unknown, Error, unknown>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: postWhatsappVerification,
    ...args,
  });
};
